import React from 'react';
import {observer, inject} from 'mobx-react';
import { Link } from 'react-router';
import {toJS} from "mobx";
import _ from "lodash";

import LeafletMap from "../LeafletMap";
import Form, {FormBody, TextInput} from "../Form";

import ObservationTaskBar from "./_commons/ObservationTaskBar";

import ObservationsTable from "./_commons/ObservationsTable";
import SelectedObservationQcTable from "./_commons/SelectedObservationQcTable";
import Spinner from "../Spinner";
import FormMultiSelectInput from "../FormMultiSelectInput";

@inject('stationStore', 'mapStore', 'hqcStore', 'qcFlagStore', 'tagStore')
@observer
export default class Map extends React.Component {
    state = {
        selectedMarker: null,
    };

    populateTagOptions = () => {
        const {tagStore, hqcStore} = this.props;
        if(tagStore.items.length === 0) {
            setTimeout(() => {
                this.populateTagOptions();
            }, 300)
        } else {
            hqcStore.setMultiTagOptions(tagStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false })));
        }
    };

    componentDidMount() {
        const {stationStore, hqcStore, tagStore} = this.props;
        const {setReferenceMarker, setCircle, distance, multiTagOptions} = hqcStore;

        tagStore.fetchItems();

        if(multiTagOptions.length === 0) {
            this.populateTagOptions();
        }

        stationStore.fetchItems().then((stations) => {
            const {selectedDataSeries} = this.props.hqcStore;

            if(selectedDataSeries.length > 0) {
                const station = stations.find(i => +i.id === +selectedDataSeries[0].station_id);

                setCircle({latLng: [station.latitude, station.longitude], radius: +distance * 1000});
                setReferenceMarker(selectedDataSeries[0].station_id);

                // setTimeout(() => {
                //     setDistance(26);
                //     setCircle({latLng: [station.latitude, station.longitude], radius: 26 * 1000});
                // }, 500);
            }
        });

        this.props.qcFlagStore.fetchItems();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {getNewlyAddedObservations, setObservations, setData} = this.props.hqcStore;

        if(nextProps.hqcStore.selectedDataSeries.length > 0) {
            if (toJS(this.props.hqcStore.selectedDataSeries) !== toJS(nextProps.hqcStore.selectedDataSeries) || !_.isEqual(toJS(this.props.hqcStore.selectedDataSeries), toJS(nextProps.hqcStore.selectedDataSeries))) {
                getNewlyAddedObservations();
            }
        } else {
            setData([]);
            setObservations([]);
        }
    }

    onMarkerOver = marker => this.setState({selectedMarker: marker.id.split('-')[1]});

    getDistance(origin, destination) {
        // return distance in meters
        const lon1 = this.toRadian(origin[1]),
            lat1 = this.toRadian(origin[0]),
            lon2 = this.toRadian(destination[1]),
            lat2 = this.toRadian(destination[0]);

        const deltaLat = lat2 - lat1;
        const deltaLon = lon2 - lon1;

        const a = Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(deltaLon / 2), 2);
        const c = 2 * Math.asin(Math.sqrt(a));
        const EARTH_RADIUS = 6371;

        return c * EARTH_RADIUS * 1000;
    }

    toRadian(degree) {
        return degree * Math.PI / 180;
    }

    getPopupBox = marker => {
        return (
            <div id={'station_marker-' + marker.id + '-popup'} style={{maxHeight: '300px'}}>
                <div style={{fontSize: '15px', fontWeight: 'bold'}}>{marker.name}</div>
                <span className="fa fa-close" style={{position: 'absolute', right: 2, top: 2}}
                      onClick={() => this.setState({selectedMarker: null})}/>
            </div>
        );
    };

    // onMarkerClick = (marker) => {
    //     const { distance, setCircle, setReferenceMarker } = this.props.hqcStore;
    //
    //     setCircle({latLng: marker.position, radius: +distance * 1000});
    //
    //     setReferenceMarker(marker.id.split('-')[1])
    // }

    getStationsWithinRange = (stations) => {
        const { referenceMarker, distance, searchTags } = this.props.hqcStore;

        if (referenceMarker) {
            const referenceStation = stations.find(station => +station.id === +referenceMarker);

            return stations.map(station => ({
                ...station,
                distance: this.getDistance([station.latitude, station.longitude], [referenceStation.latitude, referenceStation.longitude])
            })).filter(station => {
                if(+station.id === +referenceMarker)
                    return true;

                if(+station.distance < +distance * 1000) {
                    if (station.tags && station.tags.length > 0) {
                        if (searchTags.length > 0) {
                            const stationTags = station.tags.map(item => item.name.toLowerCase());

                            return searchTags.find(tag => stationTags.includes(tag.toLowerCase()));
                        } else {
                            return true;
                        }
                    }
                }
                return false;
            }).sort((a, b) => +a.distance - +b.distance);
        } else {
            return [];
        }
    }

    getQcFlagEntryByFlag = (flag) => {
        return this.props.qcFlagStore.items.find(item => item.caption === flag);
    };

    onTagSelect = (item) => {
        item.value = !item.value;
        this.props.hqcStore.setSearchTags(this.props.hqcStore.multiTagOptions.filter(item => !!item.value).map(item => item.name));
    }

    render() {
        const {stationStore, hqcStore, tagStore} = this.props;
        const {selectedMarker} = this.state;
        const {
            data,
            circle,
            date_to,
            distance,
            isLoading,
            date_from,
            multiTagOptions,
            referenceMarker,
            setData,
            handleToChange,
            setObservations,
            getObservations,
            handleFromChange,
            setReferenceMarker,
            setSelectedDataSeries,
            setSelectedObservations,
        } = hqcStore;

        if (isLoading) {
            return <Spinner/>;
        }

        const filteredStations = stationStore.items.filter(station => station.latitude && station.longitude);

        const stationsWithinRange = this.getStationsWithinRange(filteredStations);
        const referenceStation = referenceMarker ? filteredStations.find(station => +station.id === +referenceMarker) : null;

        const markers = stationsWithinRange.map(station => {
            return Object.assign({}, {
                position: [station.latitude, station.longitude],
                id: `station_marker-${station.id}`,
                icon: `<img id=${'station_marker_image-' + station.id} style="margin-left: -5px; margin-top: -30px;" src=${+selectedMarker === +station.id ? "/markers/marker-yellow.png" : +referenceMarker === +station.id ? "/markers/marker-red.png" : "/markers/marker-blue.png"} />`,
            });
        });

        return <div>
            <ObservationTaskBar slug={'analysis/hqc/map'}
                                reset={(e) => {
                                    e.preventDefault();

                                    setObservations([]);
                                    setSelectedObservations([]);
                                    setData([]);
                                    setSelectedDataSeries([]);
                                    setReferenceMarker(null);
                                }}
                                date_from={date_from}
                                date_to={date_to}
                                handleFromChange={handleFromChange}
                                handleToChange={handleToChange}
                                getObservations={getObservations}/>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div style={{flex: 2}}>
                    <LeafletMap height={'100%'}
                                id='HQC_Map'
                                center={referenceStation ? {lat: referenceStation.latitude, lng: referenceStation.longitude} : {lat: 27.70169, lng: 85.3206}}
                                markers={markers}
                                onMarkerOver={this.onMarkerOver}
                                circle={toJS(circle)}>
                        {
                            selectedMarker ? <div
                                    className='map-info-box'>{this.getPopupBox(filteredStations.find(item => +item.id === +selectedMarker))}</div>
                                : null
                        }
                    </LeafletMap>
                </div>
                {referenceStation && <div style={{
                    flex: 1,
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingLeft: '20px'
                }}>
                    <div style={{textAlign: 'center', width: '100%', color: 'white', backgroundColor: '#3c8dbc', padding: '10px 0'}}>
                                    <span>
                                        Reference Point
                                    </span>
                    </div>
                    <div>
                        <Form>
                            <FormBody>
                                {/*<div>*/}
                                    {/*<SelectInput value={referenceMarker}*/}
                                    {/*             label={'Station'}*/}
                                    {/*             filterOptions={stationStore.filterStations}*/}
                                    {/*             fields={{label: 'name', value: 'id'}}*/}
                                    {/*             onChange={(e) => {*/}
                                    {/*                 const {setCircle, distance} = this.props.hqcStore;*/}
                                    {/*                 const station = filteredStations.find(station => +station.id === +e.target.value);*/}

                                    {/*                 setCircle({*/}
                                    {/*                     latLng: [station.latitude, station.longitude],*/}
                                    {/*                     radius: +distance * 1000*/}
                                    {/*                 });*/}

                                    {/*                 setReferenceMarker(e.target.value);*/}
                                    {/*             }}*/}
                                    {/*             options={filteredStations}/>*/}
                                {/*</div>*/}
                                {referenceStation && [
                                    <TextInput key={'station'} readOnly={true} label={'Station'}
                                               value={referenceStation.name}/>,
                                    <TextInput key={'stationIdentifier'} readOnly={true} label={'Identifier'}
                                               value={referenceStation.identifier}/>
                                               ]
                                }
                            </FormBody>
                        </Form>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        padding: '20px',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{paddingRight: '10px'}}>
                            <label>Distance: </label>
                        </div>
                        <div>
                            <input type="range" min="1" max="100" value={distance} onChange={(e) => {
                                const {setDistance, setCircle, circle} = this.props.hqcStore;

                                setDistance(e.target.value);
                                setCircle(circle ? {latLng: circle.latLng, radius: +e.target.value * 1000} : null);
                            }}/>
                            {distance} km
                        </div>
                    </div>
                        <div style={{textAlign: 'center', width: '100%', color: 'white', backgroundColor: '#3c8dbc', padding: '10px 0'}}>
                            <span>
                                Nearby Stations
                            </span>
                        </div>
                        <Form style={{color: 'black'}}>
                            <FormMultiSelectInput id='tag-multi-select' label='Tags' options={multiTagOptions} optionClicked={item => this.onTagSelect(item)} isLoading={tagStore.isLoading} />
                        </Form>
                    <div style={{width: '100%', height: '400px', overflow: 'auto', position: 'relative'}}>
                    <table style={{width: '100%', textAlign: 'center'}}>
                            <thead>
                                <tr>
                                    <th style={{
                                        textAlign: 'center',
                                        position: 'sticky',
                                        top: 0,
                                        padding: '10px',
                                        backgroundColor: '#3c8dbc'
                                    }}>
                                        Station
                                    </th>
                                    <th style={{
                                        textAlign: 'center',
                                        position: 'sticky',
                                        padding: '10px',
                                        top: 0,
                                        backgroundColor: '#3c8dbc'
                                    }}>
                                        Distance
                                    </th>
                                    <th style={{
                                        textAlign: 'center',
                                        padding: '10px',
                                        position: 'sticky',
                                        top: 0,
                                        backgroundColor: '#3c8dbc'
                                    }}/>
                                </tr>
                            </thead>
                            <tbody>
                            {stationsWithinRange.length > 0 ? stationsWithinRange.map(station => {
                                return <tr key={station.id}>
                                    <td style={{textAlign: 'center'}}>
                                        {station.name}
                                    </td>
                                    <td style={{textAlign: 'center'}}>
                                        {(+station.distance / 1000).toFixed(2)} km
                                    </td>
                                    <td>
                                        <Link to={`/analysis/hqc/add_parameter?slug=analysis/hqc/map&station_id=${station.id}`} ><i className={'fa fa-plus'}/></Link>
                                    </td>
                                </tr>
                            }) : <tr>
                                <td colSpan={3}>No Stations in Range</td>
                            </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>}
            </div>
            <div>
                {
                    data.length > 0 &&
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <div style={{marginTop: '20px', height: '500px', overflow: 'auto', flex: 3}}>
                            <ObservationsTable getQcFlagEntryByFlag={this.getQcFlagEntryByFlag}/>
                        </div>
                        <div style={{flex: 1}}>
                            <SelectedObservationQcTable flags={this.props.qcFlagStore.items}
                                                        getQcFlagEntryByFlag={this.getQcFlagEntryByFlag}/>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/HQC/Map.js